// extracted by mini-css-extract-plugin
export default {"container":"Bullet_container__LQ-RX","bullet":"Bullet_bullet__lmM9e","likeAnimation":"Bullet_likeAnimation__Yy59u"};